import { render, staticRenderFns } from "./circle-arrow-icon.vue?vue&type=template&id=4364f310&"
import script from "./circle-arrow-icon.vue?vue&type=script&lang=ts&"
export * from "./circle-arrow-icon.vue?vue&type=script&lang=ts&"
import style0 from "./circle-arrow-icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports